import {
  binCountSessionIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";

export const addBinToCountSession = {
  name: "addBinToCountSession" as const,
  input: z.object({
    binCountSessionId: binCountSessionIdFormat.schema,
    storageLocationId: storageLocationIdFormat.schema,
  }),
  output: z.object({ success: z.boolean() }),
};
